export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/listIcon-f9e0d77340133afd9aac32cad335f929.svg";